<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <div class="btn-group" role="group" aria-label="basic">
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('Pendiente')">Pendiente</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('Elaborado')">Elaborado</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('EnTransito')">En Transito</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('Retornado')">Retornados</button>
                    </div>
                </div>
            </template>

            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Folio</th>
                <th :class="StyleTh">Número</th>
                <th :class="StyleTh">Cotización</th>
                <th :class="StyleTh">Clientes</th>
                <th :class="StyleTh">Fecha del Evento</th>
                <th :class="StyleTh">Estatus Solicitud</th>
                <!-- <th :class="StyleTh">Estatus Salida Extra</th> -->
                    
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>
    
            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{lista.Folio}}</h6></td>
                        <td><p :class="StyleTd">{{lista.SecuenciaLogistica}}</p></td>
                        <td><p :class="StyleTd">{{lista.FolioCotizacion}}</p></td>
                        <td><p :class="StyleTd">{{lista.NombreClientes}}</p></td>
                        <td><p :class="StyleTd">{{lista.FechaEvento}}</p></td>
                        <td><p :class="StyleTd"></p>
                            <span :class="ObtenerEtiqueta(lista,'class')">{{ObtenerEtiqueta(lista,'Name')}}</span>
                        </td>
                        <!-- <td><p :class="StyleTd"></p>
                            <template v-if="ValidaNodoExtra(lista)">
                                <span :class="ObtenerEtiquetaExtra(lista,'class')">{{ObtenerEtiquetaExtra(lista,'Name')}}</span>
                            </template>
                        </td> -->
                        
                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="false" :pShowBtnDelete="false" :pIsModal="false" :pId="lista.IdMovimientoAlmacen" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
                            <template slot="btnaccion">
                                <template v-if="lista.Estatus=='Pendiente'">
                                    <button @click="IrASolicitud(lista)" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1">
                                        <i class="far fa-clipboard text-primary"></i> 
                                        {{ lista.Estatus=='Pendiente' ? 'Ver Solicitud' : '' }}
                                    </button>
                                </template>

                                <template v-if="lista.Estatus=='Elaborado'">
                                    <button @click="MarcarSalida(lista,'normal')" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1">
                                        <i class="fas fa-chevron-circle-left"></i>
                                        Marcar Salida
                                    </button>
                                </template>

                                <template v-if="lista.Estatus=='EnTransito'">
                                    <button @click="RealizarEntradas(lista,'normal')" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1">
                                        <i class="fas fa-reply"></i>
                                        Retornar
                                    </button>
                                </template>

                                <template v-if="lista.Estatus=='EnTransito' || lista.Estatus=='Retornado'">
                                <CMoreButtonsL>
                                    <template slot="bodyBtnsL">
    
                                        <li v-if="lista.Estatus!='Elaborado'" @click="VerPdf(lista)">
                                            <a class="dropdown-item">
                                                <i class="far fa-file-pdf"></i> Ver PDF Salida
                                            </a>
                                        </li>

                                        <li v-if="lista.Estatus=='Retornado'" @click="VerPdfE(lista)">
                                            <a class="dropdown-item">
                                                <i class="far fa-file-pdf"></i> Ver PDF Entrada
                                            </a>
                                        </li>

                                        <li v-if="lista.Estatus=='EnTransito' && PermiteNodoExtra(lista)" @click="EjecutaSolicitudExtra(lista)">
                                            <a class="dropdown-item">
                                                <i class="far fa-clipboard"></i> Realizar Salida Extra
                                            </a>
                                        </li>

                                        <!-- <template v-if="ValidaNodoExtra(lista)">
                                            <li v-if="lista.salida_extra.Estatus!='PendienteE'" @click="VerPdfExtra(lista)">
                                                <a class="dropdown-item">
                                                    <i class="far fa-file-pdf"></i> Ver PDF Salida Extra
                                                </a>
                                            </li>
                                        </template> -->

                                        <!-- <template v-if="ValidaNodoExtra(lista)">
                                            <li v-if="lista.salida_extra.Estatus=='RetornadoE'" @click="VerPdfExtraE(lista)">
                                                <a class="dropdown-item">
                                                    <i class="far fa-file-pdf"></i> Ver PDF Entrada Extra
                                                </a>
                                            </li>
                                        </template> -->

                                        <!-- <template v-if="ValidaNodoExtra(lista)">
                                            <li v-if="lista.salida_extra.Estatus=='ElaboradoE'" @click="MarcarSalida(lista,'extra')">
                                                <a class="dropdown-item">
                                                    <i class="fas fa-chevron-circle-left"></i> Marcar Salida Extra
                                                </a>
                                            </li>
                                        </template> -->

                                        <!-- <template v-if="ValidaNodoExtra(lista)">
                                            <li v-if="lista.salida_extra.Estatus=='PorAutorizar'" @click="CambiarStatusExtra(lista,'SO')">
                                                <a class="dropdown-item">
                                                    <i class="far fa-send"></i> Solicitar Autorización
                                                </a>
                                            </li>
                                        </template> -->

                                        <!-- <template v-if="ValidaNodoExtra(lista)">
                                            <li v-if="lista.salida_extra.Estatus=='Autorizado'" @click="CambiarStatusExtra(lista,'AU')">
                                                <a class="dropdown-item">
                                                    <i class="far fa-check-circle"></i> Autorizar Salida Extra
                                                </a>
                                            </li>
                                        </template> -->
    
                                        <!--
                                        <li v-if="lista.EstatusSolicitud=='Elaborado' && lista.IdSolicitudSalidaExtra==''" @click="VerificarSalida(lista,'normal')">
                                            <a class="dropdown-item">
                                                <i class="far fa-clipboard-check"></i> Confirmar Salidas
                                            </a>
                                        </li>

                                        <li v-if="lista.EstatusSalidaExtra=='Elaborado' && lista.IdSolicitudSalidaExtra!=''" @click="VerificarSalida(lista,'extra')">
                                            <a class="dropdown-item">
                                                <i class="far fa-clipboard-check"></i> Confirmar Salidas Extra
                                            </a>
                                        </li>

                                        <li v-if="lista.EstatusSolicitud=='Autorizada'" @click="RealizarEntradas(lista)">
                                            <a class="dropdown-item">
                                                <i class="far fa-clipboard-check"></i> Realizar Entradas
                                            </a>
                                        </li>
                                        -->
                                    </template>
                                </CMoreButtonsL>
                                </template>
                            </template>
                        </CBtnAccion>     
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="8"></CSinRegistros>
            </template>
        </CList>

        <CModal :pConfigModal="ConfigModalAutorizarSalida" :poBtnSave="oBtnSaveAutorizarSalida">
			<template slot="Form">
				<FormAutorizarSalida :poBtnSave="oBtnSaveAutorizarSalida"></FormAutorizarSalida>
			</template>
		</CModal>

        <CModal :pConfigModal="ConfigModalAutorizarSalidaExtra" :poBtnSave="oBtnSaveAutorizarSalidaExtra">
			<template slot="Form">
				<FormAutorizarSalidaExtra :poBtnSave="oBtnSaveAutorizarSalidaExtra"></FormAutorizarSalidaExtra>
			</template>
		</CModal>

        <CModal :pConfigModal="ConfigModalEntrada" :poBtnSave="oBtnSaveEntrada">
			<template slot="Form">
				<FormEntrada :poBtnSave="oBtnSaveEntrada"></FormEntrada>
			</template>
		</CModal>
    </div>

</template>
<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
import FormAutorizarSalida from './modales/AutorizarSalidaForm.vue';
import FormAutorizarSalidaExtra from './modales/AutorizarSalidaExtraForm.vue';
import FormEntrada from './modales/EntradaForm.vue';
const EmitEjecuta = 'seccionSolicitudAlmacen';
const EmitModalSalidas = 'seccionSalidas';
const EmitModalSalidasExtra = 'seccionSalidasExtra';
const EmitModalEntradas = 'seccionEntradas';

export default {
    name: 'ListaSolicitudAlmacen',
    props: ['sFiltros','pOrigen'],
    components: {
        FormAutorizarSalida,FormEntrada,FormAutorizarSalidaExtra
    },
    data() {
        return {
            ConfigList:{
                Title: 'Solicitudes',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: '',
                GoRoute: 'RouterDelForm',
                BtnNewShow:false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Estatus: 'Pendiente',
            ConfigModalAutorizarSalida:{
                ModalTitle: "Lista de Salidas",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitModalSalidas,
				// ModalSize:'xl',
                FullScreen: true,
                Obj:{}
            },
            ConfigModalAutorizarSalidaExtra:{
                ModalTitle: "Lista de Salidas",
                ModalNameId: 'ModalForm4',
                EmitSeccion: EmitModalSalidasExtra,
				// ModalSize:'xl',
                FullScreen: true,
                Obj:{}
            },
            ConfigModalEntrada:{
                ModalTitle: "Lista de Entradas",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitModalEntradas,
				// ModalSize:'xl',
                FullScreen: true,
                Obj:{}
            },
            oBtnSaveAutorizarSalida:{
                Toast: 0,
                DisableBtn: false,
                EmitSeccion: EmitModalSalidas,
            },
            oBtnSaveAutorizarSalidaExtra:{
                Toast: 0,
                DisableBtn: false,
                EmitSeccion: EmitModalSalidasExtra,
            },
            oBtnSaveEntrada:{
                Toast: 0,
                DisableBtn: false,
                EmitSeccion: EmitModalEntradas,
            },
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("movimientosAlmacen",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    TipoSalida: 'Eventos',
                    Estatus: this.Estatus,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                // this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('movimientosAlmacen/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        SeleccionLista(Estatus)
        {
            this.Estatus = Estatus;
            this.Lista();
        },
        IrASolicitud(item){
            this.$router.push({name:'solicitudalmacenForm', params:{Id: item.IdMovimientoAlmacen, IdCotizacion: item.IdCotizacion, FechaEvento: item.FechaEvento, pObjCotizacion: item}});
        },
        MarcarSalida(item,camino){
            if (camino=='extra') {
                this.bus.$emit('NewModal_'+this.ConfigModalAutorizarSalidaExtra.EmitSeccion,item.IdCotizacion,item);
            }
            else{
                this.bus.$emit('NewModal_'+this.ConfigModalAutorizarSalida.EmitSeccion,item.IdCotizacion,item);
            }
        },
        ValidaNodoExtra(item) {
            return item.salida_extra !== null && typeof item.salida_extra === 'object';
        },
        ObtenerEtiqueta(item,Tipo)
        {
            let Estatus = item.Estatus;
            let Etiqueta = '';
            let Nombre = '';

            // SI LO QUE ESTAMOS PIDIENDO ES EL ESTATUS ENTONCES SOLO ESO REGRESA
            // DE LO CONTRARIO RETORNA EL TIPO DE ETIQUETA
            switch(Estatus)
            {
                case 'Pendiente': Nombre = 'Pendiente'; Etiqueta = 'badge bg-secondary'; break;
                case 'Elaborado': Nombre = 'Elaborado'; Etiqueta = 'badge bg-info text-black'; break;
                case 'EnTransito': Nombre = 'En Transito'; Etiqueta = 'badge bg-success text-black'; break;
                case 'Retornado': Nombre = 'Retornado'; Etiqueta = 'badge bg-danger'; break;
            }

            return (Tipo == 'class') ? Etiqueta : Nombre;
        },
        ObtenerEtiquetaExtra(item,Tipo)
        {
            // SINO EXISTE EL NODO ENTONCES RETORNAMOS VACIO
            if (!this.ValidaNodoExtra(item)) return '';

            let Estatus = item.salida_extra.Estatus;
            let Etiqueta = '';
            let Nombre = '';

            // SI LO QUE ESTAMOS PIDIENDO ES EL ESTATUS ENTONCES SOLO ESO REGRESA
            // DE LO CONTRARIO RETORNA EL TIPO DE ETIQUETA
            switch(Estatus)
            {
                case 'PendienteE': Nombre = 'Pendiente'; Etiqueta = 'badge bg-secondary'; break;
                case 'ElaboradoE': Nombre = 'Elaborado'; Etiqueta = 'badge bg-info text-black'; break;
                case 'PorAutorizar': Nombre = 'Por Autorizar'; Etiqueta = 'badge bg-warning'; break;
                case 'EnTransitoE': Nombre = 'En Transito'; Etiqueta = 'badge bg-success'; break;
            }

            return (Tipo == 'class') ? Etiqueta : Nombre;
        },
        PermiteNodoExtra(item)
        {
            // SI NO EXISTE EL NODO ENTONCES PERMITE VERLO
            if (!this.ValidaNodoExtra(item)) {
                return true;
            }
            else
            {
                // SI YA EXISTE ENTONCES SOLO PERMITE VERLO SI ESTA EN PENDIENTE
                if(item.salida_extra.Estatus == 'PendienteE'){
                    return true;
                }
            }
        },
        EjecutaSolicitudExtra(item)
        {
            let IdSalidaExtra = 0;
            // SI EXISTE EL NODO EXTRA ENTONCES TOMA EL VALOR EL ID
            if (this.ValidaNodoExtra(item)) {
                IdSalidaExtra = item.salida_extra.IdSalidaExtra;
            }

            this.IrASolicitudExtraoficial(item,IdSalidaExtra);
        },
        IrASolicitudExtraoficial(item,IdEnviado){
            console.log(IdEnviado)
            this.$router.push({name:'solicitudsalidaextraForm', params:{IdMovimientoAlmacen: IdEnviado, IdCotizacion: item.IdCotizacion, FechaEvento: item.FechaEvento, pObjAsociado: item}});
        },
        CambiarStatusExtra(item,Tipo)
        {
            if(Tipo == 'AU'){

            }
        },
        VerPdf(item)
        {
            this.ConfigList.ShowLoader = true;

            let newRequest = {
				IdMovimientoAlmacen: item.IdMovimientoAlmacen
			}

			this.$http.post('rptpdfAlmacen',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("Salida Almacen",'CheckList_'+item.IdMovimientoAlmacen,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
                
			}).catch(err=>{   
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        VerPdfE(item)
        {
            this.ConfigList.ShowLoader = true;

            let newRequest = {
				IdMovimientoAlmacen: item.IdMovimientoAlmacen
			}

			this.$http.post('rptpdfAlmacenE',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("Entrada Almacen",'CheckList_'+item.IdMovimientoAlmacen,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
                
			}).catch(err=>{   
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        VerPdfExtra(item)
        {
            this.ConfigList.ShowLoader = true;

            let newRequest = {
				IdMovimientoAlmacen: item.salida_extra.IdSalidaExtra
			}

			this.$http.post('rptpdfAlmacenExtra',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("Salida Almacen Extra",'CheckList_'+item.salida_extra.IdSalidaExtra,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
                
			}).catch(err=>{   
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        VerPdfExtraE(item)
        {
            // PDF ENTRADA EXTRA
            this.ConfigList.ShowLoader = true;

            let newRequest = {
				IdMovimientoAlmacen: item.salida_extra.IdSalidaExtra
			}

			this.$http.post('rptpdfAlmacenEntExtra',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("Entrada Almacen Extra",'CheckList_'+item.salida_extra.IdSalidaExtra,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
                
			}).catch(err=>{   
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        RealizarEntradas(item){
            this.bus.$emit('NewModal_'+this.ConfigModalEntrada.EmitSeccion,item.IdCotizacion,item);
        }
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
